export default "__VITE_ASSET__D$aXyCbu__"